import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { TimesheetCode } from "@app/models/rest/timesheet-code";

@Injectable({
  providedIn: "root"
})
export class TimesheetCodeRestService extends HateoasResourceOperation<TimesheetCode> {
  constructor() {
    super(TimesheetCode);
  }
}
